// Service Worker registration — only in production builds.
// In dev (localhost) it's skipped to avoid caching live edits.

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Allow SW only on HTTPS or localhost (PWA requirement).
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const isHttps = window.location.protocol === "https:";
  if (!isHttps && !isLocalhost) return;

  // Skip registration in development (CRA dev server doesn't serve /sw.js)
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Check for updates every hour
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch(() => { /* silent */ });
  });
}
